import React, { useRef, useState } from "react";
import { Tooltip } from "@progress/kendo-react-tooltip";
import { icon, label, notifyIcon, number } from "../../config";
import FormSharePopup from "../Forms/FormSharePopup";
import { createWorkflowTask } from "../TaskSidebar/sidebar.helper";
import WorkflowSharePopup from "../Workflow/WorkflowSharePopup";
import "./collabCentral.scss";
import { useSelector } from "react-redux";

/**
 * Parent Component : CollabCentral
 * Description : Renders Card for each workflow
 *  @author Sarthak Arora
 */
const WorkflowCard = ({ item, setShowPopup, onOpenFormFiller }) => {
  const [showSharePopup, setShowSharePopup] = useState(false);
  const [showFormSharePopup, setShowFormSharePopup] = useState(false);
  const shareIconRef = useRef();
  const { privacyStatus } = useSelector((state) => state.tasks.defaultDetails);
  const privacy = privacyStatus?.find((privacy) => privacy?.PrivacyId === item?.Privacy);
  /**
   *  opens the share workflow popup or handles form sharing
   *  @author Sarthak Arora
   */
  const handleClickShareIcon = (e) => {
    e.stopPropagation();

    if (item?.isForm) {
      // Handle form sharing - show form share popup
      setShowFormSharePopup(true);
    } else {
      // Handle workflow sharing - show workflow popup
      setShowSharePopup(true);
    }
  };
  /**
   *  opens the workflow on click of the card
   *  @author Sarthak Arora
   */
  const handleCardClick = async (item) => {
    if (item?.isForm) {
      // Call the form opening function passed from parent
      onOpenFormFiller?.(item);
    } else {
      createWorkflowTask(item?.Id, item?.ProjectId);
      setShowPopup();
    }
  };

  return (
    <>
      <div
        key={item?.Id}
        id='workflow-card-container'
        className='workflow-card-collab-central border cursor-pointer justify-content-between position-relative'
        onClick={() => handleCardClick(item)}>
        <div className='workflow-details d-flex position-relative align-items-center'>
          <div className={`mr-3 collab-workflow-icon ${item?.Privacy == number.ONE ? "black-icon" : item?.Privacy == number.TWO ? "sky-blue-icon" : item?.Privacy == number.THREE ? "maroon" : item?.Privacy == number.FOUR ? "sky-blue-icon" : "black-icon"} `}>
            {icon[item?.Icon]}
          </div>
          <div className='workflow-content'>
            <div className='pr-3 workflow-title cursor-pointer mb-0 text-truncate'>{item?.Name}</div>
            <div className='workflow-footer d-flex justify-content-start'>
              <span className='d-flex align-items-center line-height-normal'>
                {item.ProjectName}
                <span className='ml-2 workflow-form-type-icon'>{item?.isForm ? icon.FORMS : icon.DESCRIPTION_WORKFLOW}</span>
              </span>
            </div>
          </div>
          <span className='share-section position-absolute' id='workflow-card-share-icon' ref={shareIconRef} onClick={handleClickShareIcon}>
            {icon.SHARE}
          </span>
        </div>
        <p className='workflow-description mt-2 '>{item?.Description}</p>
        {item?.isForm && <div className='d-flex justify-content-between mt-auto pt-2'>
            <p className='workflow-description hover-text'>{label.FORM}</p>
            <p className='workflow-description hover-text'>{label.PRIVACY} : {privacy?.PrivacyType}</p>
          </div>
        }
      </div>

      {showSharePopup && (
        <WorkflowSharePopup
          showPopup={showSharePopup}
          shareIconAnchor={shareIconRef}
          workflowId={item?.Id}
          workflowName={item?.Name}
          projectId={item?.ProjectId}
          closeCopyLinkPopup={() => setShowSharePopup(false)}
          setShowSharePopup={setShowSharePopup}
        />
      )}

      {showFormSharePopup && (
        <FormSharePopup
          showPopup={showFormSharePopup}
          shareIconAnchor={shareIconRef}
          formId={item?.Id}
          formName={item?.Name}
          closeCopyLinkPopup={() => setShowFormSharePopup(false)}
          setShowSharePopup={setShowFormSharePopup}
        />
      )}
    </>
  );
};

export default WorkflowCard;
